import type { PayloadAction } from '@reduxjs/toolkit'
import type { AuthState } from '../slices/authSlice'

const setTokens = (
  state: AuthState,
  action: PayloadAction<{
    idToken: string
    accessToken: string
    accessTokenExpiration: number
    refreshToken: string
    refreshTokenExpiration: number
  }>,
) => {
  state.idToken = action.payload.idToken
  state.accessToken = action.payload.accessToken
  state.accessTokenExpiration = action.payload.accessTokenExpiration
  state.refreshToken = action.payload.refreshToken
  state.refreshTokenExpiration = action.payload.refreshTokenExpiration
}

const setOriginalAuth = (
  state: AuthState,
  action: PayloadAction<{
    idToken: string
    refreshToken: string
  }>,
) => {
  state.originalAuth = {
    idToken: action.payload.idToken,
    refreshToken: action.payload.refreshToken,
  }
}

const deleteOriginalAuth = (state: AuthState) => {
  state.originalAuth = undefined
}

export { setTokens, setOriginalAuth, deleteOriginalAuth }
